import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SwitchProfileRequest } from '@cash-web/shared-util-protos/squareup/cash/janus/api/AccountholderProfile.pb'
import { SwitchProfileResponse } from '@cash-web/shared-util-protos/squareup/cash/janus/api/AccountholderProfile.pb'

export const switchProfile = (request: SwitchProfileRequest, options?: CashRequestOptions) =>
  post<SwitchProfileRequest, SwitchProfileResponse>('/2.0/cash/switch-profile', request, {
    ...options,
    rejectOnError: true,
  })
